import styled from 'styled-components'
import { Link } from 'gatsby'

import { Colors, FontRegular } from './../../utils/variables'

export const Wrapper = styled.aside`
    position: fixed;

    top: ${props => props.active ? `0` : `-100%`};
    left: 0;

    z-index: 1;
    
    width: 100%;

    padding-top: 70px;
    background-color: ${Colors.white};
    border-bottom: 1px solid rgba(0, 0, 0, 0.1);

    transition: top 0.4s ease-out;
`

export const List = styled.ul`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: flex-start;

    border-top: 1px solid rgba(0, 0, 0, 0.1);

    width: 100%;

    a {
        color: ${props => (props.theme === 'light') ? `${Colors.white}` : `${Colors.blue}`};
    }
`

export const Item = styled.li`
    position: relative;
    display: block;

    width: 100%;

    margin-right: 0;
    padding: 15px 30px;

    border-bottom: 1px solid rgba(0, 0, 0, 0.1);

    &:last-of-type {
        margin-bottom: 0;
        border-bottom: 0;
    }
`

export const StyledLink = styled(Link).attrs({ activeClassName: 'active' })`
    position: relative;
    display: block;

    ${FontRegular}
    font-size: 13px;
    line-height: 12px;
    letter-spacing: 1px;

    opacity: 0.5;

    text-transform: uppercase;
    text-decoration: none;

    transition: opacity 0.15s ease-out;

    &.active {
        opacity: 1;

        + img {
            opacity: 1;
        }
    }
`

export const NoPageLink = styled.span`
    position: relative;
    display: block;

    ${FontRegular}
    font-size: 13px;
    line-height: 12px;
    letter-spacing: 1px;

    opacity: 0.5;

    text-transform: uppercase;
    text-decoration: none;

    transition: opacity 0.15s ease-out;

    &.active {
        opacity: 1;

        + img {
            opacity: 1;
        }
    }
`

export const Button = styled.button`
    position: absolute;

    top: 0;
    right: 0;

    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;

    width: 50px;
    height: 40px;

    outline: none;
    border: none;
    border-radius: 0;

    background-color: transparent;
`

export const Icon = styled.img`
    width: 6px;
    height: 6px;

    opacity: 0.5;

    transition: all 0.15s ease-out;
`

export const SubList = styled.ul`
    display: none;
    
    width: 100%;

    padding: 10px 0;

    &.open {
        display: block;
    }
`

export const SubItem = styled.li`
    display: block;
    
    width: 100%;

    margin-top: 10px;
    padding: 5px 0;
`

export const SubLink = styled(Link)`
    display: block;

    ${FontRegular}
    font-size: 13px;
    line-height: 12px;
    // letter-spacing: 1px;

    // text-transform: uppercase;
    text-decoration: none;

    opacity: 0.5;

    color: ${Colors.blue};
`